import Button from "./button.atom";

export default Button;
